import { CaretRightIcon } from '@phosphor-icons/react'
import styles from './ReportBreadcrumb.module.scss'

/**
 * ReportBreadcrumb — the drill path for the Investigations mode
 * (Investigations / Group / Cycle or Node / Entity). Every crumb except the
 * last is a button that pops back to that depth; the last crumb is the
 * current view. Renders nothing for a single crumb (root).
 *
 * @param {Array<{label: string, onClick?: Function}>} props.crumbs
 */
export const ReportBreadcrumb = ({ crumbs = [] }) => {
    if (!crumbs || crumbs.length <= 1) return null

    return (
        <nav className={styles.breadcrumb} aria-label="Breadcrumb">
            {crumbs.map((crumb, index) => {
                const isLast = index === crumbs.length - 1
                return (
                    <span key={`${crumb.label}-${index}`} className={styles.crumbWrapper}>
                        {index > 0 && (
                            <CaretRightIcon size={12} className={styles.separator} aria-hidden />
                        )}
                        {crumb.onClick && !isLast ? (
                            <button type="button" className={styles.crumbLink} onClick={crumb.onClick}>
                                {crumb.label}
                            </button>
                        ) : (
                            <span className={isLast ? styles.crumbCurrent : styles.crumbText}>
                                {crumb.label}
                            </span>
                        )}
                    </span>
                )
            })}
        </nav>
    )
}
